import React from "react";
import { useState } from "react";
import '../HomePage/Quotes.css';
import editingDetail from '../Images/Editing-icon.png';
import { convertIntoLakh } from "./UtilityComponents/UilityFunctions";
import { useSharedDataContext } from "../components/SharedDataContext";

const FormDetail = ({ setShowForm }) => {

    const { sharedData } = useSharedDataContext();
    const { Occupacyid, pincode,   buildingComponent, propertyType, descriptionOfOccupancy } = sharedData?.QuotePageDetails;
    return (
        <>
            <div className="Form_detail row">
                <div className="col-lg-10">
                    <ul className="detail1 mb-0 p-0">
                        {(propertyType === "BUILDING" || propertyType === "Both") && <><li className="area_detail">
                            <small>Building Area</small>
                            <p><b>{buildingComponent.areaOfBuilding} <span><small>sq.ft</small></span></b></p>
                        </li>
                        <li className="area_detail2">
                            <small>Rate per sq.ft</small>
                                <p><b>₹{convertIntoLakh(Math.round(parseInt(buildingComponent.valueOfBuilding) / parseInt(buildingComponent.areaOfBuilding)))}</b></p>
                        </li>
                        <li className="area_detail1">
                            <small>Value of building</small>
                                <p><b>₹{convertIntoLakh(buildingComponent.valueOfBuilding)}</b></p>
                            </li></>}
                        {(propertyType === "HOUSEHOLD" || propertyType === "Both") && <li className="area_detail area_detail3">
                            <small>Value of HouseHold ITEM</small>
                            <p><b>₹ {buildingComponent.valueOfHouseHoldItem }</b></p>
                        </li>}
                        <li className="area_detail2">
                            <small>PIN code</small>
                            <p><b>{pincode}</b></p>
                        </li>
                        <li className="area_detail2">
                            <small>Occupancy</small>
                            <p><b>{descriptionOfOccupancy?.descriptionOfOccupancy}</b></p>
                        </li>
                        <li className="Edit_detail area_detail1">
                            <button onClick={() => setShowForm(true)}>
                                <img className="" src={editingDetail} alt="Home Insurance at Lowest Rates" />
                                Edit
                            </button>
                        </li>
                    </ul>
                </div>
                {/*<div className="col-lg-2">
                    <div className="row">
                        <div className="col-md-11">
                            <div className="policy_term">
                                <span className="d-block mt-2">Policy Term</span>
                                <select value={policyTerm} onChange={setPolicyTerm}>
                                    <option value="1">1 year</option>
                                    <option value="2">2 years</option>
                                    <option value="3">3 years</option>
                                    <option value="4">4 years</option>
                                    <option value="5">5 years</option>
                                    <option value="6">6 years</option>
                                    <option value="7">7 years</option>
                                    <option value="8">8 years</option>
                                    <option value="9">9 years</option>
                                    <option value="10">10 years</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>*/}
            </div>

        </>
    );
}
export default FormDetail;